"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var actions = _interopRequireWildcard(require("../actions/orderHistoryActions"));
var _arrayHelper = require("../../helpers/arrayHelper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  openOrders: [],
  openOrdersStartIndex: 0,
  inactiveOrders: [],
  inactiveOrdersStartIndex: 0,
  accountTrades: [],
  accountTradesStartIndex: 0,
  tradeReports: [],
  tradeReportsStartIndex: 0,
  recentActivity: [],
  interestAccruals: [],
  recentActivityStartIndex: 0,
  recentActivityLoading: false,
  recentActivityTransactionReferenceTypes: ['1', '2', '3', '4'],
  activeRequests: 0,
  //Used for pagination
  openOrdersNextPage: [],
  accountTradesNextPage: [],
  tradeReportsNextPage: [],
  nextPageOrdersLoading: false
};
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case actions.REQUEST_RECENT_ACTIVITY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          recentActivityLoading: true,
          recentActivityStartIndex: payload.StartIndex
        });
      }
    case actions.RECEIVE_RECENT_ACTIVITY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          recentActivityLoading: false,
          recentActivity: payload.data
        });
      }
    case actions.RECEIVE_INTEREST_ACCRUALS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          interestAccruals: payload.data
        });
      }
    case actions.RECEIVE_TRADE_HISTORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountTrades: (0, _arrayHelper.distinct)(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case actions.REQUEST_INACTIVE_ORDERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        inactiveOrdersStartIndex: payload.StartIndex
      });
    case actions.REQUEST_OPEN_ORDERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        openOrdersStartIndex: payload.StartIndex
      });
    case actions.REQUEST_OPEN_ORDERS_NEXT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        nextPageOrdersLoading: true
      });
    case actions.REQUEST_TRADE_REPORTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        activeTradeReportsStartIndex: payload.StartIndex
      });
    case actions.REQUEST_ACCOUNT_TRADES:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        accountTradesStartIndex: payload.StartIndex
      });
    case actions.REQUEST_ACCOUNT_TRADES_NEXT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: ++state.activeRequests,
        nextPageOrdersLoading: true
      });
    case actions.RECEIVE_ACCOUNT_TRADES:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        accountTrades: (0, _arrayHelper.distinct)(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case actions.RECEIVE_ACCOUNT_TRADES_NEXT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        accountTradesNextPage: (0, _arrayHelper.distinct)(payload, function (trade) {
          return trade.TradeId;
        }),
        nextPageOrdersLoading: false
      });
    case actions.ADD_ACCOUNT_TRADE:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountTrades: [payload].concat(_toConsumableArray(state.accountTrades))
      });
    case actions.RECEIVE_OPEN_ORDERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        openOrders: payload
      });
    case actions.RECEIVE_OPEN_ORDERS_NEXT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        openOrdersNextPage: payload,
        nextPageOrdersLoading: false
      });
    case actions.ADD_OPEN_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        openOrders: (0, _arrayHelper.distinct)([payload].concat(_toConsumableArray(state.openOrders)), function (order) {
          return order.OrderId;
        })
      });
    case actions.RECEIVE_INACTIVE_ORDERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        inactiveOrders: payload
      });
    case actions.ADD_INACTIVE_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        inactiveOrders: [payload].concat(_toConsumableArray(state.inactiveOrders)),
        openOrders: filterOpenOrders(state.openOrders, payload)
      });
    case actions.RECEIVE_TRADE_REPORTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests,
        tradeReports: payload
      });
    case actions.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        accountTrades: (0, _arrayHelper.distinct)([].concat(_toConsumableArray(Array.isArray(payload) ? payload : []), _toConsumableArray(state.accountTrades)), function (trade) {
          return trade.TradeId;
        })
      });
    case actions.REMOVE_ACTIVE_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeRequests: --state.activeRequests
      });
    default:
      return state;
  }
}
var filterOpenOrders = function filterOpenOrders(openOrders, order) {
  return openOrders ? openOrders.filter(function (_ref2) {
    var OrderId = _ref2.OrderId;
    return OrderId !== order.OrderId;
  }) : [];
};